var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateExpiryDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 479.7 90",
    style: {
      enableBackground: "new 0 0 479.7 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.6,10.1h222.5c3.2,0,11.7,0,14.5-2.3c3.1-2.5,2.6-6.9,2.6-7.2c-0.3,0-4.7-0.6-7.2,2.6 c-2.3,2.8-2.3,9.6-2.3,12.4v52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.6,68.4v3.7c0,3.2,0,11.7,2.3,14.5c2.5,3.1,6.9,2.6,7.2,2.6c0-0.3,0.6-4.7-2.6-7.2 c-2.8-2.3-9.6-2.3-12.4-2.3l-344.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.1,79.9H17.6c-3.2,0-11.7,0-14.5,2.3c-3.1,2.5-2.6,6.9-2.6,7.2c0.3,0,4.7,0.6,7.2-2.6 c2.3-2.8,2.3-9.6,2.3-12.4V21.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,21.5l0-3.9c0-3.2,0-11.7-2.3-14.5C5.2,0,0.8,0.5,0.6,0.6c0,0.3-0.6,4.7,2.6,7.2 c2.8,2.3,9.6,2.3,12.4,2.3l224.1,0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateExpiryDate);
export default __webpack_public_path__ + "static/media/certificate-expiry-date.92dd347cf9c5787251a072cc9fa45d38.svg";
export { ForwardRef as ReactComponent };